import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/ru-RU";
import "./assets/scss/style.scss";
import axios from "axios";
import globalFunctions from "./globalFunctions";
import moment from "moment";
import icon from "@/components/icons";

axios.interceptors.request.use(
  function (config) {
    store.commit("setLoadingIcon", true);
    return config;
  },
  function (error) {
    store.commit("setLoadingIcon", false);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    store.commit("setLoadingIcon", false);
    return response;
  },
  function (error) {
    store.commit("setLoadingIcon", false);
    return Promise.reject(error);
  }
);
//
axios.defaults.withCredentials = true;
axios.defaults.baseURL = "https://teacher.open-college.ru";
Vue.prototype.axios = axios;
Vue.prototype.globalFunctions = globalFunctions;
Vue.prototype.$moment = moment;

Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

export const bus = new Vue();

Vue.component('v-icon', icon);

(async () => {
  await store.dispatch('auth/auth');
  await store.dispatch("auth/me");
  
  try {
    new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount("#content");
  } catch (error) {
    console.warn(error);
  }
})();
